export const ROLES = Object.freeze({
  SUPER_ADMIN: "super-admin",
  ADMIN: "admin",
  CAREDESK: "caredesk",
  FINANCE: "finance",
  MASTER: "master",
  DOCTOR: "doctor",
  TECHNICIAN: "technician",
});

// Admin works as Care Desk + Finance — everything except Master and User
// Master. Same rule as the backend's expandRoles (constants/roles.js).
const IMPLIED_ROLES = { [ROLES.ADMIN]: [ROLES.CAREDESK, ROLES.FINANCE] };
const effectiveRoles = (user) => (user?.roles || []).flatMap((r) => [r, ...(IMPLIED_ROLES[r] || [])]);

export const hasRole = (user, role) => effectiveRoles(user).includes(role);

export const hasAnyRole = (user, roles = []) => effectiveRoles(user).some((r) => roles.includes(r));

export const isSuperAdmin = (user) => hasRole(user, ROLES.SUPER_ADMIN);

// A technician-only login — sees just its own departments' worklists.
export const isPureTechnician = (user) =>
  (user?.roles || []).length > 0 && user.roles.every((r) => r === ROLES.TECHNICIAN);
